import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {MatDatepicker, MatDatepickerInputEvent} from '@angular/material/datepicker';
import {EmailTemplateModel} from '../../../models/EmailTemplateModel';

@Component({
  selector: 'app-multi-datepicker',
  templateUrl: './multi-datepicker.component.html',
  styleUrls: ['./multi-datepicker.component.scss']
})
export class MultiDatepickerComponent implements OnChanges {
  public CLOSE_ON_SELECTED = false;
  public init = new Date();
  public resetModel = new Date(0);
  @Input() template: EmailTemplateModel;

  public model = [
    // new Date('7/15/1966'),
    // new Date('3/23/1968'),
    // new Date('7/4/1992'),
    // new Date('1/25/1994'),
    // new Date('6/17/1998')
  ];
  dateFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
    const preventWE =  day !== 0 && day !== 6;
    const preventPast = d ? d.getTime() > new Date().getTime() : true;
    return preventWE && preventPast;
  }

  // @ViewChild('picker', { static: true }) _picker: MatDatepicker<Date>;
  @ViewChild(MatDatepicker, { static: true }) _picker: MatDatepicker<Date>;

  public dateClass = (date: Date) => {
    if (this._findDate(date) !== -1) {
      return [ 'selected' ];
    }
    return [ ];
  }

  public dateChanged(event: MatDatepickerInputEvent<Date>): void {
    if (event.value) {
      const date = event.value;
      const index = this._findDate(date);
      if (index === -1) {
        this.model.push(date);
      } else {
        this.model.splice(index, 1);
      }
      this.resetModel = new Date(0);
      if (!this.CLOSE_ON_SELECTED) {
        const closeFn = this._picker.close;
        this._picker.close = () => { };
        this._picker['_popupComponentRef'].instance._calendar.monthView._createWeekCells();
        setTimeout(() => {
          this._picker.close = closeFn;
        });
      }
    }
  }

  public remove(date: Date): void {
    const index = this._findDate(date);
    this.model.splice(index, 1);
  }

  private _findDate(date: Date): number {
    return this.model.map((m) => +m).indexOf(+date);
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('template' in changes) {
      this.model = this.template.dateListByTemplate;
    }
  }
}
